module.exports = __webpack_public_path__ + "img/truck-purple.ac9e2b83.svg";